var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotemark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1558 0.599609L18.7793 5.25937C13.8715 8.46944 9.57726 14.6825 8.96379 19.6529C9.06604 19.6529 10.1907 19.3423 11.0087 19.3423C15.303 19.3423 18.4725 22.7594 18.4725 27.2121C18.4725 31.8718 14.7917 35.5996 10.1907 35.5996C5.18067 35.5996 0.681824 31.4576 0.681824 23.7949C0.784069 14.3718 6.1009 5.57003 13.1558 0.599609ZM37.6947 0.599609L43.3182 5.25937C38.4104 8.46944 34.1161 14.6825 33.5027 19.6529C33.8094 19.6529 34.9341 19.3423 35.5476 19.3423C39.8419 19.3423 43.0114 22.7594 43.0114 27.2121C43.0114 31.8718 39.3306 35.5996 34.7296 35.5996C29.7195 35.5996 25.2207 31.4576 25.2207 23.7949C25.3229 14.3718 30.6398 5.57003 37.6947 0.599609Z",
    fill: "#0068B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotemark);
export default __webpack_public_path__ + "static/media/quotemark.98745cc9c09d38af10db68180d1c9036.svg";
export { ForwardRef as ReactComponent };